<template>
  <div>
    <ul class="ranklist">
      <li v-for="(item, a) in Data" :key="a">
        <div>
          <a href @click="todigest($event, item.ArticleID, item.Title)">{{
            item.Title
          }}</a>
        </div>
        <div>
          {{ item.AuthorsList }}
        </div>
        <div>DOI:{{ item.DOI }}</div>
        <div>
          <div class="ml_methods">
            <el-collapse v-model="activeName" accordion class="mobLista">
              <el-collapse-item>
                <template
                  style="border: none; padding: 0"
                  class="menthodsBut"
                  v-slot:title
                >
                  <i class="list_img zhaiyao"> </i>摘要
                  <i class="rotator">
                    <img src="../../../assets/images/down.png" />
                  </i>
                </template>
                <div class="leftfloat Abstract_drop_title">摘要：</div>
                <div
                  class="leftfloat Abstract_drop_con"
                  v-html="item.Abstract_Chinese"
                ></div>
                <div class="clearfix"></div>
                <div class="leftfloat Abstract_drop_title" v-if="isEnzhaiy">
                  Abstract：
                </div>
                <div
                  class="leftfloat Abstract_drop_con"
                  v-if="isEnzhaiy"
                  v-html="item.Abstract_English"
                ></div>
                <div class="clearfix"></div>
              </el-collapse-item>
            </el-collapse>
            <el-popover placement="bottom-end" width="160" class="pclista">
              <div class="well">
                <div class="leftfloat Abstract_drop_title">摘要：</div>
                <div
                  class="leftfloat Abstract_drop_con"
                  v-html="item.Abstract_Chinese"
                ></div>
                <div class="clearfix"></div>
                <div class="leftfloat Abstract_drop_title" v-if="isEnzhaiy">
                  Abstract：
                </div>
                <div
                  class="leftfloat Abstract_drop_con"
                  v-if="isEnzhaiy"
                  v-html="item.Abstract_English"
                ></div>
                <div class="clearfix"></div>
              </div>
              <template v-slot:reference>
                <el-button style="border: none; padding: 0" class="menthodsBut">
                  <i class="list_img zhaiyao"> </i>摘要
                  <i class="rotator">
                    <img src="../../../assets/images/down.png" />
                  </i>
                </el-button>
              </template>
            </el-popover>
            <a
              @click="todigest($event, item.ArticleID, item.Title, type)"
              class="menthodsBut"
            >
              <i class="list_img liulan"></i>浏览(<span
                style="color: red; margin-right: 0px !important"
                >{{ item.View_Times }}</span
              >)
            </a>
            <a
              @click="goHTML(item.HtmlFileUrl, item.ArticleID, item.IsOA)"
              class="menthodsBut"
              v-if="item.HtmlFileUrl"
              target="_blank"
            >
              <i class="list_img browse"></i>
              [HTML](<span style="color: red; margin-right: 0px !important">{{
                item.HtmlRead_Times
              }}</span
              >)
            </a>
            <a @click="goExport(item.ArticleID)" class="menthodsBut">
              <i class="list_img export"></i>导出
            </a>
            <a
              @click="pdf(index, item.PDFFile_Size, item.ArticleID, item.IsOA)"
              v-if="item.PDFFile_Size > 0"
              class="menthodsBut"
            >
              <i class="list_img down"></i>
              PDF下载
              <span class="">({{ item.Read_Times }})</span>
            </a>
            <a
              @click="oniscode(item.HtmlFileUrl, item.IsOA)"
              class="menthodsBut"
              v-if="item.HtmlFileUrl"
              title="扫码阅读HTML全文"
            >
              <i class="list_img Scancode"></i>扫码
            </a>
          </div>
          <el-dialog
            v-model="centerDialogVisible"
            width="30%"
            center
            class="codedialog"
          >
            <p>扫码阅读HTML全文</p>
            <vue-qr :text="codeId" :size="150" class="Qrcode"></vue-qr>
          </el-dialog>
        </div>
      </li>
    </ul>
    <div class="clearfix"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      Data: [],
      activeName: 1,
      isEnzhaiy: true,
      codeId: 0,
      centerDialogVisible: false,
    }
  },
  props: ['params'],
  mounted() {
    this.$store
      .dispatch('_getXZPH', this.params)
      .then((res) => {
        this.Data = res.data.Data
      })
      .catch((err) => {
        console.log(err)
      })
  },
  methods: {
    todigest(e, id, title, type) {
      let path = ''

      path = '/digest?ArticleID=' + id

      e.preventDefault()
      let routeUrl = this.$router.resolve({
             path: path,
        query:{ArticleID:id}
      })
      window.open(routeUrl.href, '_blank')
    },
    oniscode(url, isoa) {
      if (!this.isdownb) {
        if (!isoa) {
          alert('只有登录用户才可以扫码查看HTML')
          return
        } else {
          this.centerDialogVisible = true
          this.codeId = url
        }
      } else {
        this.centerDialogVisible = true
        this.codeId = url
      }
    },
    goHTML(url, ids, isoa) {
      if (!this.isdownb) {
        if (!isoa) {
          alert('只有登录用户才可以查看HTML')
          return
        } else {
          this.$store
            .dispatch('_getHtmlRead', { id: ids })
            .then((res) => {})
            .catch((err) => {
              console.log(err)
            })
          this.$newOpen(url)
        }
      } else {
        this.$store
          .dispatch('_getHtmlRead', { id: ids })
          .then((res) => {})
          .catch((err) => {
            console.log(err)
          })
        this.$newOpen(url)
      }
    },
    goExport(ids) {
      this.$newOpen('/#/Export?ids=' + ids)
    },
    pdf(i, size, guid, isoa) {
      if (!this.isdownb) {
        if (!isoa) {
          alert('只有登录用户才可以下载')
          return
        } else {
          if (size <= 0) {
            alert('文件不存在')
            return
          }
        }
      } else {
        if (size <= 0) {
          alert('文件不存在')
          return
        }
      }
      this.$store.dispatch('_getPDF', { Id: guid }).then((Result) => {
        if (Result.data.IsSuccess) {
          this.$Download.DownloadBase64File(
            Result.data.Data.File,
            Result.data.Data.FileName
          )
        } else {
          alert(Result.data.Message)
        }
      })
    },
    onImg() {
      this.idx = 1
      this.idxa = 0
      this.isImg = true
    },
  },
}
</script>
